// Talking Family Tree — shared constants.
//
// NOTE: Relationship options are taken verbatim from the design's red annotation
// on "Add a Family Member":
//   "Relationship to [Dream Child Name] options:
//    Grandma, Grandpa, Mom, Dad, Aunt, Uncle, Sister, Brother"

export const RELATIONSHIP_OPTIONS = [
  { value: 'grandmother', label: 'Grandma' },
  { value: 'grandfather', label: 'Grandpa' },
  { value: 'mother', label: 'Mom' },
  { value: 'father', label: 'Dad' },
  { value: 'aunt', label: 'Aunt' },
  { value: 'uncle', label: 'Uncle' },
  { value: 'sister', label: 'Sister' },
  { value: 'brother', label: 'Brother' },
];

// Group keys + display titles. Order follows the backend doc
// (parents / siblings / grandparents / aunts-and-uncles) and the design layout.
export const GROUPS = [
  { key: 'parents', title: 'Parents' },
  { key: 'grandparents', title: 'Grandparents' },
  { key: 'aunts_uncles', title: 'Aunts & Uncles' },
  { key: 'siblings', title: 'Siblings' },
  // { key: 'other', title: 'Other Family' },
];

// Maps a relationship value (or backend-derived relationship/kind string) to a group.
export const RELATIONSHIP_GROUP = {
  mom: 'parents',
  dad: 'parents',
  mother: 'parents',
  father: 'parents',
  parent: 'parents',
  sister: 'siblings',
  brother: 'siblings',
  sibling: 'siblings',
  grandma: 'grandparents',
  grandpa: 'grandparents',
  grandmother: 'grandparents',
  grandfather: 'grandparents',
  grandparent: 'grandparents',
  aunt: 'aunts_uncles',
  uncle: 'aunts_uncles',
};

export const groupForRelationship = (relationship) => {
  if (!relationship) return 'other';
  const key = String(relationship).toLowerCase().trim();
  return RELATIONSHIP_GROUP[key] || 'other';
};

// Step 1 of the invitation wizard — "Video Message Ideas".
// Topics are fetched from GET /talking_family_tree (talking-family-tree-topics) and
// grouped into sections by helpers.parseTalkingFamilyTree — NOT hardcoded here.
// The owner may pick UP TO 3.
export const MAX_VIDEO_IDEAS = 3;

// Default personal message (Step 2). Prefilled, editable, resettable.
export const defaultPersonalMessage = (babyName = 'our baby') =>
  `Hi! I'm adding a Talking Family Tree to ${babyName}'s Baby Yearbook. I’d love for you to be in it!\n\n` +
  `Please upload a profile picture and record a short video. I’ve given you a few ideas on what to talk about.\n\n` +
  `${babyName} will be able to scan it and hear from the people who love them — for years and years to come.\n\n` +
  `It only takes a couple of minutes, and it would mean the world to us. 💛`;
